<div class="banner-container">
  <img src="assets/icons/dram-capital-logo.svg" alt="">
  <img class="sphere-left" src="{{ icons.sphere3 }}" alt="">
  <img class="sphere-right" src="{{ icons.sphere3 }}" alt="">
</div>
